/**
 * Вход и выход из забежки через API. Telegram — тихо по initData (+ `start_param`), браузер — гость по cookie.
 * Ошибка входа бой не останавливает: первый экран — игра, прогресс догонит синхронизация (I2).
 */
import type { Locale } from "@newfungame/contracts";
import { ApiError } from "@newfungame/contracts";
import type { ApiTransport } from "../api";
import type { LaunchInfo } from "./launch";
import { appStore, openStartupWindows, runEnded, type Store, type AppState } from "./store";

function errorCode(e: unknown): string {
  return e instanceof ApiError ? e.code : "network";
}

export async function signIn(
  api: ApiTransport,
  launch: Pick<LaunchInfo, "miniApp" | "initData" | "startParam">,
  locale: Locale,
  store: Store<AppState> = appStore,
): Promise<void> {
  store.set((s) => ({ ...s, auth: { ...s.auth, status: "pending", error: null } }));
  const { landing } = store.get();
  const from = landing ? { landing } : {};
  try {
    const r =
      launch.miniApp && launch.initData
        ? await api.call("authTelegram", {
            initData: launch.initData,
            ...(launch.startParam ? { startParam: launch.startParam } : {}),
            ...from,
          })
        : await api.call("authGuest", { locale, ...from });
    store.set((s) => ({
      ...s,
      player: r.state,
      auth: {
        status: "ready",
        guest: r.state.player.telegramId === null,
        created: r.created,
        error: null,
        history: r.history,
      },
    }));
    openStartupWindows(store);
  } catch (e) {
    store.set((s) => ({ ...s, auth: { ...s.auth, status: "error", error: errorCode(e) } }));
  }
}

/**
 * Выход из забежки (`exitRun`): усиления сгорают, сервер начинает новую забежку. Не вошли — нечего закрывать (сервер
 * закроет сам). Ошибка сети — тоже оставляем серверу.
 */
export async function exitRun(
  api: ApiTransport,
  reason: "backgroundTimeout" | "manual",
  store: Store<AppState> = appStore,
): Promise<boolean> {
  if (!store.get().player) return false;
  try {
    runEnded(await api.call("exitRun", { reason }), store);
    return true;
  } catch {
    return false;
  }
}
